import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { useEffect } from 'react';
import { shallowEqual } from 'react-redux';
import { setNumVisiblePanelButtons } from '../redux/actions/panelsActions';
import { useAppDispatch, useAppSelector } from '../redux/store';
import { MorePanelsButton } from './morePanelsButton';
import { RightPanelButton } from './rightPanelButton';
import { calcNumVisiblePanelButtons } from './rightPanelControlsUtils';
const RESERVED_WIDTH_PX = 80;
const ASSUMED_PANEL_BUTTON_WIDTH_PX = 34;
const ASSUMED_MORE_PANELS_BUTTON_WIDTH_PX = ASSUMED_PANEL_BUTTON_WIDTH_PX;
const BUTTONS_CONTAINER_CSS = css `
  display: flex;
  flex-direction: row;
`;
function getPanelTypesWithPriority(panelTypes, panelPriority) {
    return panelPriority.filter((currPanelType) => panelTypes.includes(currPanelType));
}
export const RightPanelControls = () => {
    const dispatch = useAppDispatch();
    const panelTypes = useAppSelector((state) => state.panels.panels.map(({ type }) => type), shallowEqual);
    const panelPriority = useAppSelector((state) => state.session.panelPriority, shallowEqual);
    const numVisiblePanelButtons = useAppSelector((state) => state.panels.numVisiblePanelButtons);
    const canHidePanel = useAppSelector((state) => state.panels.canHidePanel);
    const appDimensions = useAppSelector((state) => state.session.appDimensions, shallowEqual);
    useEffect(() => {
        const newNumVisiblePanelButtons = calcNumVisiblePanelButtons(panelTypes, appDimensions, RESERVED_WIDTH_PX, ASSUMED_PANEL_BUTTON_WIDTH_PX, ASSUMED_MORE_PANELS_BUTTON_WIDTH_PX);
        if (newNumVisiblePanelButtons !== undefined && newNumVisiblePanelButtons !== numVisiblePanelButtons) {
            dispatch(setNumVisiblePanelButtons(newNumVisiblePanelButtons));
        }
    }, [appDimensions, dispatch, numVisiblePanelButtons, panelTypes]);
    if (numVisiblePanelButtons === undefined) {
        return null;
    }
    const panelTypesWithPriority = getPanelTypesWithPriority(panelTypes, panelPriority);
    const visiblePanelTypes = numVisiblePanelButtons < panelTypesWithPriority.length
        ? panelTypesWithPriority.slice(0, numVisiblePanelButtons)
        : panelTypesWithPriority;
    const hiddenPanelTypes = numVisiblePanelButtons < panelTypesWithPriority.length
        ? panelTypesWithPriority.slice(numVisiblePanelButtons)
        : undefined;
    return (_jsxs("div", { css: BUTTONS_CONTAINER_CSS, children: [visiblePanelTypes.map((panelType) => (_jsx(RightPanelButton, { panelType: panelType, canHidePanel: canHidePanel }, panelType))), hiddenPanelTypes && _jsx(MorePanelsButton, { panelTypes: hiddenPanelTypes })] }));
};
